import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  decrypt,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { IoIosCheckmark } from "react-icons/io";
import { Disclosure } from "@headlessui/react";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import Select from "react-select";
import { ToastContainer } from "react-toastify";
import { getCookie } from "../../helpers/CookieComponent";
import OTPInput from "react-otp-input";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValuesRegister = {
  webinarId: "",
  firstName: "",
  lastName: "",
  mobileNumber: "",
  email: "",
  pinCode: "",
  companyName: "",
  designation: "",
  country: "",
};

const initialValuesOtp = {
  registerId: "",
  otp: "",
};

// Fromik Validation Schema
const schemaRegister = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(onlyAlphabet, "First name is not valid"),
  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(onlyAlphabet, "Last name is not valid"),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  designation: Yup.string().trim().required("Select designation"),
  // companyName: Yup.string().trim().required("Select company name"),
  companyName: Yup.string().trim().required("Company name is required"),
  country: Yup.string().trim().required("Select Country"),
  pinCode: Yup.string()
    .trim()
    .required("Pin code is required")
    .matches(onlyIntRegExp, "Pin code is not valid")
    .min(4, "Pin code is not valid")
    .max(14, "Pin code is not valid"),
});

const schemaOtp = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP is invalid")
    .required("OTP is required"),
});

const WebinarDetailsTwo = () => {
  ChangeTitle("Webinar Details");
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [webinarDetails, setWebinarDetails] = useState({});
  const [openIndex, setOpenIndex] = useState(3); // State to track which accordion is open
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [companyNameList, setCompanyNameList] = useState([]);
  const [registerId, setRegisterId] = useState("");
  const webinarId = getCookie("webinarId");
  const auth = decrypt(getCookie("token")) || "";

  console.log("webinarDetails_____________________", webinarDetails);

  // Accordion open verify function
  const isOpen = (index) => openIndex === index;

  // Accordion toggle function
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Toggle or close the accordion
  };

  // Webinar Registration Api Call
  const formikRegister = useFormik({
    initialValues: initialValuesRegister,
    validationSchema: schemaRegister,
    onSubmit: async (values, { resetForm }) => {
      setLoadingRegister(true);

      const param = {
        webinarId: webinarId,
        firstName: values.firstName,
        lastName: values.lastName,
        mobileNumber: values.mobileNumber,
        email: values.email,
        pincode: values.pinCode,
        companyName: values.companyName,
        designationId: values.designation,
        countryId: values.country,
      };

      console.log(param);

      const response = await postData(
        "webinar/register",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setRegisterId(response.data.data.registerId);
        formikOtp.setFieldValue("registerId", response.data.data.registerId);
        setTimeout(() => {
          setLoadingRegister(false);
          resetForm();
          closeModal("register");
          openModal("otp");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingRegister(false);
      }
    },
  });

  // Otp Verify Api Call
  const formikOtp = useFormik({
    initialValues: initialValuesOtp,
    validationSchema: schemaOtp,
    onSubmit: async (values, { resetForm }) => {
      setLoadingOtp(true);

      const param = {
        registerId: values.registerId,
        otp: values.otp,
      };

      console.log(param);

      const response = await postData(
        "webinar/email/verification",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        // toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoadingOtp(false);
          resetForm();
          closeModal("otp");
          openModal("confirm");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingOtp(false);
      }
    },
  });

  // Company List  API Call
  const viewCompanyList = async () => {
    const param = {};
    var response = await postData("companyname/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.companyName,
        };
      });
      setCompanyNameList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // County List  API Call
  const viewCountryList = async () => {
    const param = {};
    var response = await postData(
      "country/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Designation API Call
  const viewDesignationList = async () => {
    const param = {};
    var response = await postData("designation/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.designationName,
        };
      });
      setDesignationList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Webinar Detail Api Call
  const viewWebinarList = async (id) => {
    const param = {
      webinarId: id,
    };

    var response = await postData(
      "webinar/user/detail",
      param,
      apiHeader(false)
    );
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data[0];
      setWebinarDetails(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewDesignationList();
    viewCountryList();
    viewCompanyList();
  }, []);

  useEffect(() => {
    viewWebinarList(webinarId);
  }, [webinarId]);

  const webinarDescriptionList = [
    {
      title: "Key Details",
      img: toAbsoluteUrl("media/img/user/user4.svg"),
      name: "CA Mukesh Jawaharani",
      occupation: "Chartered Accountant",

      description: {
        title: "About the Speaker:",
        para: "CA Mukesh Jawaharani is a practicing Chartered Accountant with over nineteen years of experience, specializing in Service Tax and GST. He is an Empanelled Faculty for Indirect Taxes – GST by ICAI and was a Co-opted Member of the 'Indirect Tax Committee', WIRC, ICAI for 2017-18. He is a sought-after consultant for GST litigation by many CA firms in Gujarat and has conducted numerous seminars and presentations for prestigious organizations like the Confederation of Indian Industry (CII), WIRC of ICAI, YES Bank, Kotak Bank, and other business federations. He is also an invited speaker at Uka Tarsadia University, South Gujarat, and regularly contributes articles on Indirect Tax for various publishers and national newspapers.",
      },
    },
    {
      title: "Session details",
    },
    {
      title: "Speakers",
    },
  ];

  const handleOtpChange = (value) => {
    formikOtp.setFieldValue("otp", value);
  };

  // Opem Modal Popup Form Function
  const openModal = (type) => {
    document.body.style.overflowY = "hidden";
    if (type == "register") {
      setIsRegisterModalOpen(true);
    } else if (type == "otp") {
      setIsOtpModalOpen(true);
    } else if (type == "confirm") {
      setIsConfirmModalOpen(true);
    }
  };

  // Close Modal Popup Form Function
  const closeModal = (type) => {
    document.body.style.overflowY = "";
    if (type == "register") {
      setIsRegisterModalOpen(false);
      formikRegister.resetForm();
    } else if (type == "otp") {
      setIsOtpModalOpen(false);
      formikOtp.resetForm();
    } else if (type == "confirm") {
      setIsConfirmModalOpen(false);
    }
  };

  return (
    <>
      {isRegisterModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("register")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[10%] relative  transform form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Webinar registration</h1>
                <IoClose
                  onClick={() => closeModal("register")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikRegister.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter first name"
                        name="firstName"
                        id="firstName"
                        value={formikRegister.values.firstName}
                        onChange={formikRegister.handleChange}
                      />
                      {formikRegister.touched.firstName &&
                        formikRegister.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Last name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter last name"
                        name="lastName"
                        id="lastName"
                        value={formikRegister.values.lastName}
                        onChange={formikRegister.handleChange}
                      />
                      {formikRegister.touched.lastName &&
                        formikRegister.errors.lastName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.lastName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Mobile number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter mobile number"
                        id="mobileNumber"
                        value={formikRegister.values.mobileNumber}
                        onChange={formikRegister.handleChange}
                      />
                      {formikRegister.touched.mobileNumber &&
                        formikRegister.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.mobileNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="email"
                        value={formikRegister.values.email}
                        onChange={formikRegister.handleChange}
                      />
                      {formikRegister.touched.email &&
                        formikRegister.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Pin code
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter pin code"
                        id="pinCode"
                        value={formikRegister.values.pinCode}
                        onChange={formikRegister.handleChange}
                      />
                      {formikRegister.touched.pinCode &&
                        formikRegister.errors.pinCode && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.pinCode}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Company name
                      </label>
                      {/* <Select
                        name="companyName"
                        id="companyName"
                        placeholder="Select company name"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={companyNameList}
                        value={companyNameList.find(
                          (item) =>
                            item.value === formikRegister.values.companyName
                        )}
                        onChange={(e) =>
                          formikRegister.setFieldValue("companyName", e.value)
                        }
                        styles={selectFormStyle}
                      /> */}
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Company Name"
                        id="companyName"
                        name="companyName"
                        value={formikRegister.values.companyName}
                        onChange={formikRegister.handleChange}
                      />
                      {formikRegister.touched.companyName &&
                        formikRegister.errors.companyName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.companyName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Designation
                      </label>
                      <Select
                        name="designation"
                        id="designation"
                        placeholder="Select designation"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={designationList}
                        value={designationList.find(
                          (item) =>
                            item.value === formikRegister.values.designation,
                        )}
                        onChange={(e) =>
                          formikRegister.setFieldValue("designation", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikRegister.touched.designation &&
                        formikRegister.errors.designation && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.designation}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Country
                      </label>
                      <Select
                        name="country"
                        id="country"
                        placeholder="Select country"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={countryList}
                        value={countryList.find(
                          (item) =>
                            item.value === formikRegister.values.country,
                        )}
                        onChange={(e) =>
                          formikRegister.setFieldValue("country", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikRegister.touched.country &&
                        formikRegister.errors.country && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikRegister.errors.country}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loadingRegister}
                    >
                      {!loadingRegister && <>Save and continue</>}
                      {loadingRegister && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loadingRegister}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isOtpModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("otp")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[70%] lg:w-[50%] xl:w-[50%] xxl:container p-[2%] mx-auto my-[50%] md:my-[40%] lg:my-0 relative lg:top-[35%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">OTP verification</h1>
                <IoClose
                  onClick={() => closeModal("otp")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikOtp.handleSubmit}>
                  <div className="w-full grid gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Enter OTP
                      </label>
                      <OTPInput
                        value={formikOtp.values.otp}
                        onChange={handleOtpChange}
                        numInputs={6}
                        inputType="number"
                        renderInput={(props) => <input {...props} />}
                        shouldAutoFocus={true}
                        inputStyle={{
                          justifyContent: "space-around",
                          border: "1px solid rgba(0,0,0,0.3)",
                          borderRadius: "8px",
                          width: "50px",
                          height: "50px",
                          fontSize: "1.5rem",
                          margin: "auto auto",
                          color: "#000",
                          fontWeight: "400",
                          caretColor: "blue",
                        }}
                      />
                      {formikOtp.touched.otp && formikOtp.errors.otp && (
                        <div className="mt-2 error-msg">
                          <div className="">{formikOtp.errors.otp}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loadingOtp}
                    >
                      {!loadingOtp && <>Verify OTP</>}
                      {loadingOtp && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loadingOtp}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isConfirmModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("confirm")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[2%] top-[25%] lg:my-0 relative lg:top-1/2 transform lg:-translate-y-1/2 form-box"
            >
              <div className="flex items-center mb-[5%] justify-end">
                <IoClose
                  onClick={() => closeModal("confirm")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="confirm mb-[10%]">
                <div className="w-full mb-[2%] flex justify-center">
                  <IoIosCheckmark className="items-center !rounded-full form-success-icon" />
                </div>
                <h1 className="text-center mb-[3%] confirm-h1 hanson">
                  Registration confirmed!
                </h1>
                <p className="text-center w-[90%] mx-auto confirm-p">
                  Your registration is confirmed. We have sent a confirmation
                  email with the joining link to your email address. If you
                  don't see it in your inbox, please check your Spam or Junk
                  folder.
                </p>
                <p className="text-center w-[90%] mx-auto confirm-p">
                  For any help, contact us at gcchelplaw@gmail.com
                </p>
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer />
      <div className="w-full p-[5%] section-books section-training section-webinar">
        <div className="xxl:container mx-auto">
          {webinarDetails && (
            <div className="w-full mb-[5%] flex flex-col lg:flex-row gap-10 sec-webinar">
              <div className="lg:w-[30%] sw-part1">
                <div className="mb-[5%] swp1-part1">
                  {/* <div className="w-full h-[30rem] mb-[3%]"> */}
                  <div className="w-full mb-[3%]">
                    <img
                      className="w-full h-full object-cover"
                      src={
                        webinarDetails.webinarImage &&
                        webinarDetails.webinarImage
                      }
                      alt="Webinar Image"
                    />
                  </div>
                  <h1 className="mb-[2%] swp1p1-h1">
                    {webinarDetails.webinarName && webinarDetails.webinarName}
                  </h1>
                  <div className="flex mb-[1%] gap-1 items-center">
                    <img
                      className="swp1p1-h2"
                      src={toAbsoluteUrl(
                        "media/img/icon/basic/calendar-yellow.svg",
                      )}
                      alt=""
                    />
                    <h3 className="swp1p1-h2">
                      {webinarDetails.date && webinarDetails.date}
                    </h3>
                  </div>
                  <div className="flex mb-[1%] gap-1">
                    <h2 className="swp1p1-h2">Fees:</h2>
                    <h3 className="swp1p1-h3">
                      {webinarDetails.isFree == true
                        ? "Free"
                        : webinarDetails.fees}
                    </h3>
                  </div>
                  <div className="flex mb-[1%] gap-1">
                    <h2 className="swp1p1-h2">No. of session(s):</h2>
                    <h3 className="swp1p1-h3">
                      {webinarDetails.noOfSession && webinarDetails.noOfSession}
                    </h3>
                  </div>
                </div>
                <div className="swp1-part2">
                  <div className="mb-[5%]">
                    <h1 className="mb-[2%] swp1p1-h1 swp1p2-h1">
                      About the content
                    </h1>
                    {/* <h3 className="swp1p1-h3 swp1p2-h3">
                      {webinarDetails.aboutTheContent &&
                        webinarDetails.aboutTheContent}
                    </h3> */}
                    <div
                      className="swp1p1-h3 swp1p2-h3"
                      dangerouslySetInnerHTML={{
                        __html:
                          webinarDetails.aboutTheContent &&
                          webinarDetails.aboutTheContent,
                      }}
                    />
                  </div>
                  {/* <div className="swp1p2-part2">
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Overview of the Provision
                      </h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Background of Appellate Tribunals
                      </h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Advantages of Approaching the Tribunal
                      </h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Formation and Structure of GSTAT
                      </h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Key Areas in Drafting
                      </h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">Dos and Don'ts</h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Paperbook & Synopsis Submissions
                      </h3>
                    </section>
                    <section className="w-full mb-[3%] flex gap-5 swp1p2p2">
                      <IoIosCheckmark className="items-center rrcbtick swp1p2tick" />
                      <h3 className="leading-none w-[80%]">
                        Opportunities in the Litigation Arena
                      </h3>
                    </section>
                  </div> */}
                </div>
              </div>
              <div className="lg:w-[70%] flex flex-col gap-5 sw-part2">
                <div className="p-[5%] md:p-[2%] swp2-box">
                  <div>
                    {/* Button */}
                    <button
                      onClick={() => toggleAccordion(1)}
                      className="flex mb-[3%] w-full justify-between"
                    >
                      <h1 className="swp2-title">Key details</h1>
                      {isOpen(1) ? (
                        <BiMinus className="swp2-minus" />
                      ) : (
                        <BsPlusLg className="swp2-plus" />
                      )}
                    </button>

                    {/* Panel */}
                    {isOpen(1) && (
                      <div className="text-sm">
                        <div className="swp2p2-box">
                          <div className="flex mb-[1%] gap-2">
                            <h2 className="swp1p1-h2">Time :</h2>
                            <h3 className="swp1p1-h3">
                              {webinarDetails.time && webinarDetails.time}
                            </h3>
                          </div>
                          <div className="flex mb-[1%] gap-2">
                            <h2 className="swp1p1-h2">Duration :</h2>
                            <h3 className="swp1p1-h3">
                              {webinarDetails.duration &&
                                webinarDetails.duration}{" "}
                              Minutes
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="p-[5%] md:p-[2%] swp2-box">
                  <div>
                    {/* Button */}
                    <button
                      onClick={() => toggleAccordion(2)}
                      className="flex mb-[3%] w-full justify-between"
                    >
                      <h1 className="swp2-title">Session details</h1>
                      {isOpen(2) ? (
                        <BiMinus className="swp2-minus" />
                      ) : (
                        <BsPlusLg className="swp2-plus" />
                      )}
                    </button>

                    {/* Panel */}
                    {isOpen(2) && (
                      <div className="text-sm">
                        <div className="swp2p2-box">
                          <div
                            className="swp1p1-h3"
                            dangerouslySetInnerHTML={{
                              __html:
                                webinarDetails.sessionDetail &&
                                webinarDetails.sessionDetail,
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="p-[5%] md:p-[2%] swp2-box">
                  <div>
                    {/* Button */}
                    <button
                      onClick={() => toggleAccordion(3)}
                      className="flex mb-[3%] w-full justify-between"
                    >
                      <h1 className="swp2-title">Speakers</h1>
                      {isOpen(3) ? (
                        <BiMinus className="swp2-minus" />
                      ) : (
                        <BsPlusLg className="swp2-plus" />
                      )}
                    </button>

                    {/* Panel */}
                    {isOpen(3) && (
                      <div className="text-sm">
                        <div className="swp2p2-box">
                          <div className="flex gap-5 mb-[3%]">
                            <img
                              className="w-[20%] lg:w-[15%] xl:w-[10%] swp2p2b-img"
                              src={
                                webinarDetails.speakerImage &&
                                webinarDetails.speakerImage
                              }
                              alt=""
                            />
                            {/* <img
                              className="w-[99px] h-[117px] swp2p2b-img"
                              src={
                                webinarDetails.speakerImage &&
                                webinarDetails.speakerImage
                              }
                              alt=""
                            /> */}
                            <div className="flex flex-col gap-5">
                              <h1 className="swp2p2-name">
                                {webinarDetails.speakerName &&
                                  webinarDetails.speakerName}
                              </h1>
                              <h2 className="swp2p2-tag">
                                {webinarDetails.speakerPosition &&
                                  webinarDetails.speakerPosition}
                              </h2>
                            </div>
                          </div>
                          <div>
                            <h1 className="mb-[2%] swp2p2-h1">
                              About the Speaker:
                            </h1>
                            <p className="swp2p2-about">
                              <div
                                className=""
                                dangerouslySetInnerHTML={{
                                  __html:
                                    webinarDetails.aboutSpeaker &&
                                    webinarDetails.aboutSpeaker,
                                }}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* <div key={i} className="p-[5%] md:p-[2%] swp2-box">
                  <div>
                    <button
                      onClick={() => toggleAccordion(i)}
                      className="flex mb-[3%] w-full justify-between"
                    >
                      <h1 className="swp2-title">{data.title}</h1>
                      {isOpen(i) ? (
                        <BiMinus className="swp2-minus" />
                      ) : (
                        <BsPlusLg className="swp2-plus" />
                      )}
                    </button>

                    {isOpen(i) && (
                      <div className="text-sm">
                        <div className="swp2p2-box">
                          <div className="flex gap-5 mb-[3%]">
                            <img
                              className="swp2p2b-img"
                              src={toAbsoluteUrl("media/img/user/user4.svg")}
                              alt=""
                            />
                            <div className="flex flex-col gap-5">
                              <h1 className="swp2p2-name">
                                CA Mukesh Jawaharani
                              </h1>
                              <h2 className="swp2p2-tag">
                                Chartered Accountant
                              </h2>
                            </div>
                          </div>
                          <div>
                            <h1 className="mb-[2%] swp2p2-h1">
                              About the Speaker:
                            </h1>
                            <p className="swp2p2-about">
                              CA Mukesh Jawaharani is a practicing Chartered
                              Accountant with over nineteen years of experience,
                              specializing in Service Tax and GST. He is an
                              Empanelled Faculty for Indirect Taxes – GST by
                              ICAI and was a Co-opted Member of the 'Indirect
                              Tax Committee', WIRC, ICAI for 2017-18. He is a
                              sought-after consultant for GST litigation by many
                              CA firms in Gujarat and has conducted numerous
                              seminars and presentations for prestigious
                              organizations like the Confederation of Indian
                              Industry (CII), WIRC of ICAI, YES Bank, Kotak
                              Bank, and other business federations. He is also
                              an invited speaker at Uka Tarsadia University,
                              South Gujarat, and regularly contributes articles
                              on Indirect Tax for various publishers and
                              national newspapers.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          )}
          <div className="w-full lg:w-[70%] ml-auto flex gap-10 justify-center">
            {webinarDetails?.type == 0 && (
              <>
                <button
                  onClick={() => openModal("register")}
                  className="px-[7%] py-[2%] btn-register"
                >
                  Register
                </button>
                {auth ? (
                  <a
                    target="_blank"
                    href={webinarDetails.teamLink && webinarDetails.teamLink}
                    className="px-[7%] py-[2%] btn-register btn-join-session"
                  >
                    Join session
                  </a>
                ) : (
                  <button
                    onClick={() => {
                      if (!auth) {
                        toasterrormsg("Please login first");
                        return false;
                      }
                    }}
                    className="px-[7%] py-[2%] btn-register btn-join-session"
                  >
                    Join session
                  </button>
                )}
              </>
            )}
            <a
              target="_blank"
              href={webinarDetails.youtubeLink && webinarDetails.youtubeLink}
              className={`flex items-center ${
                webinarDetails?.type == 0
                  ? "btn-live"
                  : "px-[7%] py-[2%] btn-register btn-join-session"
              }`}
            >
              {webinarDetails?.type == 0 ? "Watch live" : "Watch"}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebinarDetailsTwo;
